import { inject, Injectable, Signal } from '@angular/core';

import { Store } from '@ngrx/store';

import { createActionResponseFactory } from '@core/ngrx-legacy';
import {
  ConversationStartersActions,
  ConversationStartersSelectors,
} from '@core/tellent-assistant-data';
import {
  conversationStartersKey,
  type ConversationStarters,
  type ConversationStartersContext,
} from '@core/tellent-assistant-types';

@Injectable({ providedIn: 'root' })
export class ConversationStartersDataService {
  private readonly store = inject(Store);
  private readonly response = createActionResponseFactory(ConversationStartersActions);

  public byContext(ctx: ConversationStartersContext): Signal<ConversationStarters | null> {
    return this.store.selectSignal(
      ConversationStartersSelectors.byId(conversationStartersKey(ctx)),
    );
  }

  public loadStarters(ctx: ConversationStartersContext) {
    return this.response(
      ConversationStartersActions.fetchOne,
      { payload: { id: conversationStartersKey(ctx), ctx } },
      {
        successResponse: ({ store, action }) =>
          store.select(ConversationStartersSelectors.byId(action.payload.data.id)),
        failedResponse: ({ store, action }) =>
          store.select(ConversationStartersSelectors.error(action.payload.id)),
      },
    );
  }
}
